import { render, staticRenderFns } from "./partnerOptions.vue?vue&type=template&id=11cc07b8&"
import script from "./partnerOptions.vue?vue&type=script&lang=js&"
export * from "./partnerOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11cc07b8')) {
      api.createRecord('11cc07b8', component.options)
    } else {
      api.reload('11cc07b8', component.options)
    }
    module.hot.accept("./partnerOptions.vue?vue&type=template&id=11cc07b8&", function () {
      api.rerender('11cc07b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/partnerOptions.vue"
export default component.exports